jQuery(function(){
  jQuery('.iwish-seo-setting .seo-buttom span').on('click',function(){
    var t = jQuery(this).text();
    if(t == 'Show More'){
      jQuery('.iwish-seo-setting .seo-container').removeClass('max-height');
      jQuery(this).html('Hide');
    }else{
      jQuery('.iwish-seo-setting .seo-container').addClass('max-height');
      jQuery(this).html('Show More');
    }
  });


  jQuery('.iwish-faq-section .faq-items-box .faq-items .question-title').on('click',function(){
    let c = jQuery(this).parent('.faq-items').hasClass('active');
    if(c){
      jQuery(this).parent('.faq-items').removeClass('active');
      jQuery(this).next('.answer-content').hide();
    }else{
      jQuery(this).parent('.faq-items').addClass('active');
      jQuery(this).next('.answer-content').show();
    }
  });



});